export const basics = {
  city: 'Amsterdam',
  countryCode: 'NL',
  email: 'jasper@jasperschulte.com',
  firstName: 'Jasper',
  lastName: 'Schulte',
  linkedIn: 'https://www.linkedin.com/in/jasperschulte/',
  website: 'https://jasperschulte.com',
}
